import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  width: 100%;
  height: 100%;

  @keyframes zoomInAndOut {
    0% {
      transform: scale(1.5); /* Zoom inicial */
    }
    100% {
      transform: scale(1); /* Zoom final */
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    animation: zoomInAndOut 6s ease-in-out;
    transition: all ease 5s;

    &:hover {
      transform: scale(2);
    }
  }
`
